module.exports = __webpack_public_path__ + "img/methoden_640.b3967588.png";